
import { buildClass } from 'utils/build-classname';
import styles from './page-content.module.scss';


interface PageContentProps {
  className?: string;
  size?: 'default' | 'large' | 'max';
  children?: React.ReactNode;
}

export const PageContent = ({ size = 'default', className = '', ...props }:PageContentProps) => {
  const contentClass = buildClass(
    'otk-page-container',
    styles.content,
    size !== 'default' && styles[size],
    'dx-card',
    className,
  );
  return (
    <div className='content-block otk-content-block'>
      <div className={contentClass}>
        {props.children}
      </div>
    </div>
  );
};

